import { ascend, prop, sortBy, sortWith } from 'ramda';
import { LOCATIONS_ALL_ID } from '../../../containers/BrandBarber/constants';

const getServiceShopNameOrder = shopNamesById => service =>
  (service.shopId === LOCATIONS_ALL_ID ? '' : shopNamesById[service.shopId]);

// eslint-disable-next-line import/prefer-default-export
export const sortBrandBarberServices = (services, shopNamesById) => {
  const serviceShopNameOrder = getServiceShopNameOrder(shopNamesById);

  const sortedServices = sortWith([
    ascend(prop('order')),
    ascend(prop('name')),
    ascend(prop('id')),
  ])(services);

  sortedServices.map(sortedService => ({
    ...sortedService,
    shopIds: sortBy(serviceShopNameOrder)(sortedService.shopIds),
  }));

  return sortedServices;
};
